import React from 'react'
import PopoverMenuItem from "../../../../../../core/gd-components/popover-menu/popover-menu/menu-item"
import PopoverMenuSeparator from "../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator"
import AiAgent from "../../../../../../core/model2/ai-agent/ai-agent"
import {DEFAULT_AGENT_LABEL} from "../../../../@const"
import AiAgentAvatar from "../../../agent-avatar"
import {DEFAULT_AGENT_ID} from "../../../../../settings/ai/agents/list/default-agent"

type Props = {
    menuParams  : {
        currentAgentId  : ID | null
        onSelect        : (agentId: ID | null) => void
    }
    hidePopover : callback
}

const AVATAR_WRAP: React.CSSProperties = {marginRight: 8, display: 'inline-flex'}

export default function AiAgentPopupMenu(props: Props) {

    const {currentAgentId, onSelect} = props.menuParams

    const handleSelect = (agentId: ID | null) => {
        onSelect(agentId)
        props.hidePopover()
    }

    const handleManageAgents = () => {
        props.hidePopover()
        gd.layout.rightMain.hide()
        gd.navigation.goTo('settings/ai/agents')
    }

    const agents : AiAgent[] = gd.session.aiAgents.filterByUserAccess(gd.user.id).models

    return (
        <div className="ui5-popover-menu">
            <PopoverMenuItem
                iconComponent = {<div style={AVATAR_WRAP}><AiAgentAvatar agentId={DEFAULT_AGENT_ID} size={24}/></div>}
                label         = {DEFAULT_AGENT_LABEL}
                selected      = {!currentAgentId}
                onClick       = {() => handleSelect(null)}
            />

            {agents.map((agent: AiAgent) => (
                <PopoverMenuItem
                    key           = {agent.id}
                    iconComponent = {<div style={AVATAR_WRAP}><AiAgentAvatar agentId={agent.id} size={24}/></div>}
                    label         = {agent.name}
                    selected      = {currentAgentId === agent.id}
                    onClick       = {() => handleSelect(agent.id)}
                />
            ))}
            <PopoverMenuSeparator/>
            <PopoverMenuItem
                icon    = {"i5-wrench"}
                label   = {"Manage agents"}
                onClick = {handleManageAgents}
            />
        </div>
    )
}
